<template>
  <v-dialog
    v-model="isOpened"
    persistent
    width="680px"
  >
    <v-form @submit.prevent.native="$canWrite && (submit($event))">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar color="primary darken-1" dark>
            <v-toolbar-title>Nouveau client</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="isOpened = false">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-alert
            :value="true"
            type="error"
            class="mb-4"
            v-if="this.isEmptyName"
          >
            Veuillez remplir le champ "Nom".
          </v-alert>
          <v-col cols="12" class="pa-3">
            <v-text-field v-model="name" label="Nom" outlined hide-details required autofocus />
          </v-col>
          <v-col cols="12" class="pa-3">
            <v-checkbox
              v-model="isMonoSite"
              hide-details
              label="Client avec un seul lieu d'intervention"
              class="ma-0"
            ></v-checkbox>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="isOpened = false">Annuler</v-btn>
          <v-btn :disabled="!$canWrite" color="primary darken-1" :loading="isSaving" @click="$canWrite && (submit($event))">Ajouter</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: `NewClientDialog`,
  props: [`value`],
  data: () => ({
    name: ``,
    isMonoSite: false,
    isSaving: false,
    isEmptyName: false,
  }),
  computed: {
    isOpened: {
      get() { return this.value; },
      set(isOpened) { this.$emit(`input`, isOpened); },
    },
    ...mapState(`model/client`, [
      `clients`,
    ]),
  },
  methods: {
    initLocalState() {
      this.isSaving = false;
      this.name = ``;
    },
    async submit() {
      this.isSaving = true;
      if (this.name.length === 0) {
        this.isEmptyName = true;
        this.isSaving = false;
      } else {
        const client = await this.$store.dispatch(`model/client/addClient`, {
          name: this.name,
          isMonoSite: this.isMonoSite,
        });
        this.isSaving = false;
        this.isOpened = false;
        this.$emit(`created`, client);
      }
    },
  },
  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        this.initLocalState();
      }
    },
  },
};
</script>
